import request from "@/util/request.js";

/**
 * @function sendSmsCode 发送验证码
 * @description 使用手机号，发送短信验证码，注册码用来注册或者登录
 * @param { String } data 手机号
 */
export function sendSmsCode(data) {
  return request({
    url: "/sms/sendSmsCode",
    method: 'get',
    params: data
  })
}

/**
 * @function smsLogin 短信验证码登录
 * @description 使用接口 /sms/sendSmsCode 发送的短信验证码登录, 
 * @param { Object } data  mobile: 手机号  password: 空字符串  smsCode: 短信验证码
 * @return { Promise } code: 请求状态码，200为正常，500及其他为异常，  token：用户token,   msg: 后台消息或异常说明
 */
export function smsLogin(data){
  return request({
    url: "/sms/login",
    method: 'post',
    data: data
  })
}

/**
 * 登录方法 密码登录
 * @param {username, password, smsCode} data 
 */
export function loginByPassWord(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

/**
 * 注册
 * @param {username, password} data 
 */
export function register(data){
  return request({
    url: "/doRegister",
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getUserInfo',
    method: 'get'
  })
}

/**
 * 修改密码(更新密码)
 * @param {mobile, smsCode, oldPassword, newPassword} data 
 */
export function updatePassWord(data) {
  return request({
    url: '/restPassword',
    method: 'post',
    data: data
  })
}


/**
 * 修改密码(忘记密码)
 * @param {mobile, smsCode, password} data 
 */
export function forgetPassword(data) {
  return request({
    url: '/forgetPassword',
    method: 'post',
    data: data
  })
}

/**
 * 退出方法
 * @param {mobile, smsCode, password} data 
 */
export function logout(data) {
  return request({
    url: '/logout',
    method: 'post',
    data: data
  })
}











// WEBPACK FOOTER //
// ./src/apis/loginAndRegister/index.js